import { Target, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { GoalsHeaderProps } from "../../pages/GoalsPage";

const GoalsHeader: React.FC<GoalsHeaderProps> = ({ onNewGoal, stats }) => {
    const { t } = useTranslation();

    const totalGoals = stats.totalGoals || 0;
    const completedGoals = stats.completedGoals || 0;


    return (
        <div className="flex flex-col space-y-4">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-2xl font-bold flex items-center text-gray-900 dark:text-white">
                        <Target className="w-6 h-6 mr-2 text-blue-600 dark:text-blue-400" />
                        {t('goals.title')}
                    </h2>
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                        {totalGoals} {t('goals.overview.goals')}, {completedGoals} {t('goals.overview.completed')}
                    </p>
                </div>
                <div className="flex space-x-2">
                    <button
                        onClick={onNewGoal}
                        className="flex items-center px-4 py-2 bg-blue-600 dark:bg-blue-500 text-white rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors"
                    >
                        <Plus className="w-5 h-5 mr-2" />
                        {t('goals.newGoal')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GoalsHeader;